/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';
import { Typography, Typography2 } from '@coursera/cds-core';
import { StarFilledIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/xdp';

type Props = {
  productRating?: number | null;
  totalReviewCount?: number | null;
};

const styles = {
  wrapper: css`
    display: flex;
    align-items: center;
    align-content: center;
  `,
  iconContainer: (theme: Theme) => css`
    padding: ${theme.spacing(0, 8, 0, 4)};
    display: flex;
    align-items: center;
  `,
};

const KeyInformationHorizontalReviewsItem = ({ productRating, totalReviewCount }: Props) => {
  if (!productRating || !totalReviewCount) return null;

  return (
    <React.Fragment>
      <div css={styles.wrapper}>
        <Typography variant="h2semibold" component="div">
          {productRating.toFixed(1)}
        </Typography>
        <div css={styles.iconContainer}>
          <StarFilledIcon color="interactive" size="small" />
        </div>
      </div>
      <Typography2 component="p" variant="bodySecondary" color="supportText">
        {_t('(#{totalReviewCount} reviews)', {
          totalReviewCount: totalReviewCount.toLocaleString(),
        })}
      </Typography2>
    </React.Fragment>
  );
};

export default KeyInformationHorizontalReviewsItem;
